import { createContext, type Key } from 'react';

import type { ArgsProps } from 'antd/es/notification/interface';

interface AntNotificationContextProps {
    showError?: (args: ArgsProps) => void;
    showSuccess?: (args: ArgsProps) => void;
    showInfo?: (args: ArgsProps) => void;
    showWarning?: (args: ArgsProps) => void;
    showNotificationByArg?: (args: ArgsProps) => void;
    destroy?: (key?: Key) => void;
}

export const AntNotificationContext =
    createContext<AntNotificationContextProps>({});
